import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Heading, Paragraph } from '@digdir/designsystemet-react';
import type { WorkEnvironmentSurvey } from '../../../api/workEnvironmentTypes';
import { unavailableReason } from '../surveyProcessView';

type Props = {
  survey: WorkEnvironmentSurvey;
  /** Instead of the reason the status gives */
  reason?: 'followedUp';
};

export const SurveyUnavailable = ({ survey, reason }: Props): ReactElement => {
  const { t } = useTranslation();
  return (
    <Alert data-color="info" data-size="md">
      <Heading level={2} data-size="xs">
        {survey.title}
      </Heading>
      <Paragraph>{t(`workEnvironmentProcess.unavailable.${reason ?? unavailableReason(survey.status)}`)}</Paragraph>
    </Alert>
  );
};
